export default "__VITE_ASSET__BdX43omH__"